import { ReactNode } from "react";
import styles from "./SheetTop.module.css";

type SheetTopProps = {
  children: ReactNode;
  className?: string | undefined;
  testId?: string | undefined;
};

function SheetTop({ children, className, testId }: SheetTopProps) {
  const combinedClassName = className
    ? `${styles["root"]} ${className}`
    : styles["root"];

  return (
    <div data-testid={testId} className={combinedClassName}>
      {children}
    </div>
  );
}

export default SheetTop;
